import { getLastMonthDateRange } from '~/utils/date';
import { IFormValues } from '../types';
import { ReadingsMode } from '~/services/api/enums';
import { PatientSelectorType } from '../enums';

const getInitialValues = (): IFormValues => ({
  selectorType: PatientSelectorType.Program,
  programId: null,
  healthManagerId: null,
  patientIds: [],
  includeReadings: false,
  readingsMode: ReadingsMode.Historical,
  includeCharts: false,
  includeNotes: false,
  ...getLastMonthDateRange(),
});

export default getInitialValues;
